import { Button } from '@lacedltd/laced-components'
import * as React from 'react'
import tokens from '@lacedltd/design-tokens'
import { useAddToCart, useViewport, useTranslation } from 'hooks'
import { withTranslations, formatPrice } from 'helpers'
import { ProductInfo } from '../ProductHero/ProductHero.types'
import * as S from './StickyProductActions.styles'

const StickyProductActions: React.FC<StickyProductActionsProps> = ({
  productInfo,
  selectedPriceCents,
  selectedSizeConversionId,
  selectedFormattedDisplayPrice,
  selectedId
}) => {
  const { t } = useTranslation()
  const { width } = useViewport()

  const selectedPrice = selectedPriceCents
    ? formatPrice(selectedPriceCents, {
        currencyCode: null,
        valueIsCents: true,
        precise: true
      })
    : null

  const { addToCart, selectedSize } = useAddToCart(
    productInfo,
    selectedSizeConversionId,
    selectedPrice,
    selectedId
  )

  const isMobile = width <= tokens.breakpoints.m

  return isMobile ? (
    <S.ProductActionsWrapper data-testid="sticky-product-actions">
      <S.ProductActionsTitle as="h4">{productInfo.title}</S.ProductActionsTitle>
      <S.ProductActionsTextWrapper>
        <S.ProductActionsText variant="caption">
          {selectedFormattedDisplayPrice}
        </S.ProductActionsText>
        <S.ProductActionsText variant="caption">
          {selectedSize || productInfo.selectedSize}
        </S.ProductActionsText>
      </S.ProductActionsTextWrapper>
      <S.Divider />
      <Button variant="primary" onClick={() => addToCart()}>
        {t('shared.add_to_cart')}
      </Button>
    </S.ProductActionsWrapper>
  ) : null
}

interface StickyProductActionsProps {
  productInfo: ProductInfo
  selectedSizeConversionId: number
  selectedPriceCents: number
  selectedFormattedDisplayPrice: string
  selectedId: number
}

export default withTranslations(StickyProductActions)
